import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import { canRedirectTo } from '@core/constants/appVersion';
import { allowAutomaticAppSwitch } from '@core/utils/appSwitch';
import buildAppSwitchUrl from '@core/utils/buildAppSwitchUrl';
import useSharedStudyAppVersion from '../hooks/useSharedStudyAppVersion';
import ReadOnlyViewer from './ReadOnlyViewer';

// Shared-study links (/study/view?s=<hash>) are served on whichever app
// version the study's organization chose in Personalización (default v2),
// regardless of any Radiologist app-version preference.
const ShareLinkRedirect = () => {
  const [searchParams] = useSearchParams();
  const { isResolved, targetVersion } = useSharedStudyAppVersion(searchParams.get('s') ?? '');
  // When the target URL isn't configured (missing/unresolved pipeline
  // variable) redirecting would just replace this page's URL with itself
  // (buildAppSwitchUrl falls back to a same-origin relative path), looping
  // forever — serve the viewer locally instead. allowAutomaticAppSwitch also
  // stops a v2 <-> v3 ping-pong when both apps resolve different versions
  // (e.g. one of them failing the shared-study lookup).
  const shouldRedirect =
    isResolved && allowAutomaticAppSwitch(targetVersion) && canRedirectTo(targetVersion);

  useEffect(() => {
    if (shouldRedirect) {
      window.location.replace(buildAppSwitchUrl(targetVersion));
    }
  }, [shouldRedirect, targetVersion]);

  if (!isResolved || shouldRedirect) {
    return <Backdrop open>Cargando</Backdrop>;
  }

  return <ReadOnlyViewer />;
};

export default ShareLinkRedirect;
